export const Emotes = {
  IDLE: 'asset://mp-idle.glb',
  WALK: 'asset://mp-walk.glb?s=1.5',
  WALK_LEFT: 'asset://mp-walk-left.glb?s=1.5',
  WALK_RIGHT: 'asset://mp-walk-right.glb?s=1.5',
  WALK_BACK: 'asset://mp-walk-back.glb?s=1.5',
  WALK_BACK_LEFT: 'asset://mp-walk-backleft.glb?s=2.2',
  WALK_BACK_RIGHT: 'asset://mp-walk-backright.glb?s=2.2',
  RUN: 'asset://mp-jog.glb?s=1.4',
  RUN_LEFT: 'asset://mp-jog-left.glb?s=1.4',
  RUN_RIGHT: 'asset://mp-jog-right.glb?s=1.4',
  RUN_BACK: 'asset://mp-jog-back.glb?s=1.4',
  RUN_BACK_LEFT: 'asset://mp-jog-backleft.glb?s=2.0',
  RUN_BACK_RIGHT: 'asset://mp-jog-backright.glb?s=2.0',
  JUMP: 'asset://emote-jump.glb',
  FALL: 'asset://emote-fall.glb',
  FLY: 'asset://emote-float.glb',
  FLIP: 'asset://emote-flip.glb?s=1.1&l=0',
  BACKFLIP: 'asset://emote-backflip.glb?s=2.2&l=0',
  // [STRAFE FLIP EMOTES] New strafe flip animations integrated:
  STRAFE_LEFT_FLIP: 'asset://emote-flip-left.glb?s=1.1&l=0',
  STRAFE_RIGHT_FLIP: 'asset://emote-flip-right.glb?s=1.5&l=0',
  // [STRAFE JUMP EMOTES] Side jump animations for non-flip jumping:
  STRAFE_JUMP_LEFT: 'asset://emote-jump-left.glb?s=1.0&l=0',
  STRAFE_JUMP_RIGHT: 'asset://emote-jump-right.glb?s=1.0&l=0',
  TALK: 'asset://emote-talk.glb',
  // Platformer Mechanics Animations
  GRINDING: 'asset://mp-grinding.glb?s=1.0',
  CLIMB_IDLE: 'asset://mp-climb-idle.glb?s=1.0',
  CLIMB_UP: 'asset://mp-climb-up.glb?s=1.2',
  CLIMB_DOWN: 'asset://mp-climb-down.glb?s=1.2',
  LEDGE_HANGING_IDLE: 'asset://mp-ledge-hanging-idle.glb?s=1.0',
  LEDGE_HANGING_MOVING: 'asset://mp-ledge-hanging-moving.glb?s=1.2',
  AIR_DIVE: 'asset://mp-platformer/mp-air-dive.glb',
  WALL_SLIDE: 'asset://mp-wallslide.glb?s=1.0',
}

export const emoteUrls = [
  Emotes.IDLE,
  Emotes.WALK,
  Emotes.WALK_LEFT,
  Emotes.WALK_RIGHT,
  Emotes.WALK_BACK,
  Emotes.WALK_BACK_LEFT,
  Emotes.WALK_BACK_RIGHT,
  Emotes.RUN,
  Emotes.RUN_LEFT,
  Emotes.RUN_RIGHT,
  Emotes.RUN_BACK,
  Emotes.RUN_BACK_LEFT,
  Emotes.RUN_BACK_RIGHT,
  Emotes.JUMP,
  Emotes.FALL,
  Emotes.FLY,
  Emotes.FLIP,
  Emotes.BACKFLIP,
  Emotes.STRAFE_LEFT_FLIP,
  Emotes.STRAFE_RIGHT_FLIP,
  Emotes.STRAFE_JUMP_LEFT,
  Emotes.STRAFE_JUMP_RIGHT,
  Emotes.TALK,
  // Platformer Mechanics Animations
  Emotes.GRINDING,
  Emotes.CLIMB_IDLE,
  Emotes.CLIMB_UP,
  Emotes.CLIMB_DOWN,
  Emotes.LEDGE_HANGING_IDLE,
  Emotes.LEDGE_HANGING_MOVING,
  Emotes.AIR_DIVE,
  Emotes.WALL_SLIDE,
]
